import * as api from '../api/depreciationCategories';
import * as pricingTableApi from '../api/pricingTable';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN/DEPRECIATION-CATEGORIES';

export const FETCH_ALL_YEARS = createRequestTypes(`${prefix}/FETCH_ALL_YEARS`);

export const fetchAllYears = makeApiActionCreatorV3(
  pricingTableApi.fetchAllYears,
  FETCH_ALL_YEARS[START],
  FETCH_ALL_YEARS[SUCCESS],
  FETCH_ALL_YEARS[ERROR],
);

export const FETCH_PERSONAL_DEPRECIATION_CATEGORIES = createRequestTypes(
  `${prefix}/FETCH_PERSONAL_DEPRECIATION_CATEGORIES`,
);

export const fetchPersonalDepreciationCategories = makeApiActionCreatorV3(
  api.fetchPersonalDepreciationCategories,
  FETCH_PERSONAL_DEPRECIATION_CATEGORIES[START],
  FETCH_PERSONAL_DEPRECIATION_CATEGORIES[SUCCESS],
  FETCH_PERSONAL_DEPRECIATION_CATEGORIES[ERROR],
);

export const INSERT_PERSONAL_DEPRECIATION_CATEGORY = createRequestTypes(
  `${prefix}/INSERT_PERSONAL_DEPRECIATION_CATEGORY`,
);

export const insertPersonalDepreciationCategory = makeApiActionCreatorV3(
  api.insertPersonalDepreciationCategory,
  INSERT_PERSONAL_DEPRECIATION_CATEGORY[START],
  INSERT_PERSONAL_DEPRECIATION_CATEGORY[SUCCESS],
  INSERT_PERSONAL_DEPRECIATION_CATEGORY[ERROR],
);

export const FETCH_PERSONAL_DEPRECIATION_CATEGORY = createRequestTypes(
  `${prefix}/FETCH_PERSONAL_DEPRECIATION_CATEGORY`,
);

export const fetchPersonalDepreciationCategory = makeApiActionCreatorV3(
  api.fetchPersonalDepreciationCategory,
  FETCH_PERSONAL_DEPRECIATION_CATEGORY[START],
  FETCH_PERSONAL_DEPRECIATION_CATEGORY[SUCCESS],
  FETCH_PERSONAL_DEPRECIATION_CATEGORY[ERROR],
);

export const UPDATE_PERSONAL_DEPRECIATION_CATEGORY = createRequestTypes(
  `${prefix}/UPDATE_PERSONAL_DEPRECIATION_CATEGORY`,
);

export const updatePersonalDepreciationCategory = makeApiActionCreatorV3(
  api.updatePersonalDepreciationCategory,
  UPDATE_PERSONAL_DEPRECIATION_CATEGORY[START],
  UPDATE_PERSONAL_DEPRECIATION_CATEGORY[SUCCESS],
  UPDATE_PERSONAL_DEPRECIATION_CATEGORY[ERROR],
);

export const DELETE_PERSONAL_DEPRECIATION_CATEGORY = createRequestTypes(
  `${prefix}/DELETE_PERSONAL_DEPRECIATION_CATEGORY`,
);

export const deletePersonalDepreciationCategory = makeApiActionCreatorV3(
  api.deletePersonalDepreciationCategory,
  DELETE_PERSONAL_DEPRECIATION_CATEGORY[START],
  DELETE_PERSONAL_DEPRECIATION_CATEGORY[SUCCESS],
  DELETE_PERSONAL_DEPRECIATION_CATEGORY[ERROR],
);

export const FETCH_DEPRECIATION_METHODS = createRequestTypes(
  `${prefix}/FETCH_DEPRECIATION_METHODS`,
);

export const fetchDepreciationMethods = makeApiActionCreatorV3(
  api.fetchDepreciationMethods,
  FETCH_DEPRECIATION_METHODS[START],
  FETCH_DEPRECIATION_METHODS[SUCCESS],
  FETCH_DEPRECIATION_METHODS[ERROR],
);

export const UPDATE_PERSONAL_DEPRECIATION_CATEGORY_KEYWORDS = createRequestTypes(
  `${prefix}/UPDATE_PERSONAL_DEPRECIATION_CATEGORY_KEYWORDS`,
);

export const updatePersonalDepreciationCategoryKeywords = makeApiActionCreatorV3(
  api.updatePersonalDepreciationCategoryKeywords,
  UPDATE_PERSONAL_DEPRECIATION_CATEGORY_KEYWORDS[START],
  UPDATE_PERSONAL_DEPRECIATION_CATEGORY_KEYWORDS[SUCCESS],
  UPDATE_PERSONAL_DEPRECIATION_CATEGORY_KEYWORDS[ERROR],
);
